import { render, staticRenderFns } from "./splitter.vue?vue&type=template&id=3a46d43d&"
import script from "./splitter.vue?vue&type=script&lang=ts&"
export * from "./splitter.vue?vue&type=script&lang=ts&"
import style0 from "./splitter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports